import React from 'react';
import './Appointment.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClock,
  faCalendarCheck,
  faUserDoctor,
  faHospital
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const Appointment: React.FC = () => {
  const { t } = useTranslation();
  const features = t('appointment.features', { returnObjects: true }) as {
    title: string;
    description: string;
  }[];

  const icons = [faClock, faCalendarCheck, faUserDoctor, faHospital];

  return (
    <section className="appointment" id="appointment-section">
      <div className="container">
        <h2 >{t('appointment.title')}</h2>
        <div className="appointment-text">
          <p>{t('appointment.paragraph1')}</p>
          <p>{t('appointment.paragraph2')}</p>
        </div>
        <div className="appointment-content">
          <div className="appointment-image">
            <img src="/images/rand.jpg" alt="Prise de rendez-vous" />
          </div>

          <div className="appointment-features">
            {features.map((feature, index) => (
              <div key={index} className="feature-item">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={icons[index]} />
                </div>
                <h3  >{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Appointment;
